import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { ProductCollections } from '../../../models/product';

@Component({
  selector: 'app-shopping-cart-empty',
  imports: [RouterModule, NzEmptyModule],
  templateUrl: './shopping-cart-empty.html',
  styleUrl: './shopping-cart-empty.scss',
})
export class ShoppingCartEmpty implements OnInit {
  get newArrivalsNo(): string {
    return ProductCollections.NewArrivals;
  }

  get bestSellersNo(): string {
    return ProductCollections.BestSellers;
  }

  isNewArrivals: boolean = false;
  ngOnInit(): void {
    this.isNewArrivals = Math.random() >= 0.5;
  }
}
